import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LegalTermsFooterComponent } from './modules/ui/legal-terms-footer/legal-terms-footer.component';
import { IconsSpriteComponent } from './shared/modules/icons/components/icons-sprite/icons-sprite.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { UIView } from '@uirouter/angular';

@Component({
  selector: 'app-public-root',
  templateUrl: './app-public.component.html',
  imports: [LegalTermsFooterComponent, IconsSpriteComponent, TranslocoPipe, UIView]
})
export class AppPublicComponent {
  private document = inject(DOCUMENT);

  skipToMainContent(event: Event, targetId = 'main-content') {
    event.preventDefault();
    const target = this.document.getElementById(targetId);
    target?.focus();
  }
}
